import React from "react";

export default function Overlay({ onButtonClick }) {
  return (
    <div className="overlay-container">
      <div className="overlay">
        <div className="overlay-panel overlay-left">
          <h1>Welcome Back!</h1>
          <p>To keep connected with us please login with your personal info</p>
          <button className="ghost" onClick={() => onButtonClick("login")}>
            Sign In
          </button>
        </div>
        <div className="overlay-panel overlay-right">
          <h1>Hello, Friend!</h1>
          <p>Provide your personal information and embark on your journey with us</p>
          <button className="ghost" onClick={() => onButtonClick("signup")}>
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
}
